export const CLASSES = {
    rejected: 'red',

    pending: 'yellow',
    kyc_pending: 'yellow',

    processed: 'green',
};
